import { eq } from 'lodash/fp';
import { combineEpics } from 'redux-observable';
import { forCollectionName, error$ } from './util';
import { actions } from '../reducers';
import {
  listen,
  pushOne,
  deleteOne,
  updateOne,
  setOne,
  fetchCollection
} from '../api/firebase';

const collectionNames = ['events', 'content', 'defaultContentId'];

const collectionStreams = collectionNames.map(collectionName => {
  const pushOne$ = action$ =>
    action$
      .ofAction(actions.collections.pushOne)
      .filter(forCollectionName(collectionName))
      .map(({ item }) => item)
      .mergeMap(pushOne(collectionName))
      .map(pushed => ({ collectionName, pushed }))
      .map(actions.collections.onePushed)
      .catch(error$)
      .retry();

  const deleteOne$ = action$ =>
    action$
      .ofAction(actions.collections.deleteOne)
      .filter(forCollectionName(collectionName))
      .map(({ id }) => id)
      .mergeMap(deleteOne(collectionName))
      .map(id => ({ collectionName, id }))
      .map(actions.collections.oneDeleted)
      .catch(error$)
      .retry();

  const updateOne$ = action$ =>
    action$
      .ofAction(actions.collections.updateOne)
      .filter(forCollectionName(collectionName))
      .map(({ id, fields }) => ({ id, fields }))
      .mergeMap(updateOne(collectionName))
      .map(updated => ({ collectionName, updated }))
      .map(actions.collections.oneUpdated)
      .catch(error$)
      .retry();

  const setOne$ = action$ =>
    action$
      .ofAction(actions.collections.setOne)
      .filter(forCollectionName(collectionName))
      .map(({ value }) => value)
      .mergeMap(setOne(collectionName))
      .map(updated => ({ collectionName, updated }))
      .map(actions.collections.oneSet)
      .catch(error$)
      .retry();

  const fetch$ = action$ =>
    action$
      .ofAction(actions.collections.fetch)
      .filter(eq(collectionName))
      .mergeMap(fetchCollection(collectionName))
      .map(collection => ({ collectionName, collection }))
      .map(actions.collections.receiveCollection)
      .catch(error$)
      .retry();

  const listen$ = action$ =>
    action$
      .ofAction(actions.collections.listen)
      .filter(eq(collectionName))
      .switchMap(() =>
        listen(collectionName).takeUntil(stopListening$(action$))
      )
      .map(collection => ({ collectionName, collection }))
      .map(actions.collections.receiveCollection)
      .catch(error$)
      .retry();

  const stopListening$ = action$ =>
    action$
      .ofAction(actions.collections.stopListening)
      .filter(eq(collectionName))
      .mapTo(true)
      .catch(error$)
      .retry();

  return combineEpics(
    fetch$,
    listen$,
    pushOne$,
    deleteOne$,
    updateOne$,
    setOne$
  );
});

export default combineEpics(...collectionStreams);



// WEBPACK FOOTER //
// ./src/epics/collections.js